import { i18next } from '@/i18n'

export default {
  path: 'socialnetwork-posts/',
  name: 'social-posts',
  meta: {
    auth: 'ROLE_USER',
    title: i18next.t('layouts.postManagement')
  },
  component: () =>
    import(/* webpackChunkName: "posts" */ '../pages/socialNetworks/SocialPostsList.vue')
}
